module.exports = __webpack_public_path__ + "img/7.1a15acda.jpg";